// extracted by mini-css-extract-plugin
module.exports = {"notFound":"CqAEp","notFound_wrapper":"m7OOg","notFound_status":"ZThfa","notFound_message":"_12xLY","notFound_regular":"_1j41A"};